if (!customElements.get('collection-header')) {
  class CollectionHeader extends HTMLElement {
    constructor() {
      super();

      this.setupCarousel();
    }

    connectedCallback() {}

    setupCarousel() {
      requirejs(['swiper'], (Swiper) => {
        this.swiper = new Swiper(`.js-carousel-${this.dataset.selector}`, {
          threshold: 10,
          grabCursor: false,
          lazy: true,
          resistanceRatio: 0.7,
          speed: 300,
          slidesPerView: 'auto'
        });
      })
    }
  }

  customElements.define('collection-header', CollectionHeader);
}
